import { DateTime } from 'luxon';
import { OfferType } from './OfferType';
import {
  getEmptySpendXGetYMetadata,
  SpendXGetYMetadata,
  spendXGetYMetadataFromResponse,
  spendXGetYMetadataToUpsertRequest,
} from './Metadata/SpendXGetY';
import {
  FreeShippingMetadata,
  freeShippingMetadataFromResponse,
  freeShippingMetadataToUpsertRequest,
} from './Metadata/FreeShipping';
import { TranslatedText } from '../Translation';
import {
  BasketDiscountMetadata,
  basketDiscountMetadataFromResponse,
  basketDiscountMetadataToUpsertRequest,
} from './Metadata/BasketDiscount';

export interface Offer {
  id: number;
  type: OfferType;
  name: string;
  nameTranslation: TranslatedText;
  description: string;
  descriptionTranslation: TranslatedText;
  startAt: Date;
  endAt: Date;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
  isDeleted: boolean;

  spendXGetYMetadata?: SpendXGetYMetadata;
  freeShippingMetadata?: FreeShippingMetadata;
  basketDiscountMetadata?: BasketDiscountMetadata;
}

export const getEmptyOffer = (): Offer => ({
  id: 0,
  type: OfferType.SPEND_X_GET_Y,
  name: '',
  nameTranslation: {},
  description: '',
  descriptionTranslation: {},
  startAt: new Date(),
  endAt: new Date(),
  isActive: false,
  createdAt: new Date(),
  updatedAt: new Date(),
  isDeleted: false,

  spendXGetYMetadata: getEmptySpendXGetYMetadata(),
});

export const offerFromResponse = (responseData: any): Offer => ({
  id: responseData.id,
  type: responseData.type,
  name: responseData.name,
  nameTranslation: responseData.name_translation ?? {},
  description: responseData.description,
  descriptionTranslation: responseData.description_translation ?? {},
  startAt: new Date(responseData.start_at),
  endAt: new Date(responseData.end_at),
  isActive: responseData.is_active,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
  isDeleted: responseData.is_deleted,

  spendXGetYMetadata: responseData.spend_x_get_y_metadata
    ? spendXGetYMetadataFromResponse(responseData.spend_x_get_y_metadata)
    : undefined,
  freeShippingMetadata: responseData.free_shipping_metadata
    ? freeShippingMetadataFromResponse(responseData.free_shipping_metadata)
    : undefined,
  basketDiscountMetadata: responseData.basket_discount_metadata
    ? basketDiscountMetadataFromResponse(responseData.basket_discount_metadata)
    : undefined,
});

export const offerToUpsertRequest = (offer: Offer) => ({
  type: offer.type,
  name: offer.name,
  name_translation: offer.nameTranslation,
  description: offer.description,
  description_translation: offer.descriptionTranslation,
  start_at: DateTime.fromJSDate(offer.startAt).toISO(),
  end_at: DateTime.fromJSDate(offer.endAt).toISO(),
  is_active: offer.isActive,

  spend_x_get_y_metadata: offer.spendXGetYMetadata
    ? spendXGetYMetadataToUpsertRequest(offer.spendXGetYMetadata)
    : undefined,
  free_shipping_metadata: offer.freeShippingMetadata
    ? freeShippingMetadataToUpsertRequest(offer.freeShippingMetadata)
    : undefined,
  basket_discount_metadata: offer.basketDiscountMetadata
    ? basketDiscountMetadataToUpsertRequest(offer.basketDiscountMetadata)
    : undefined,
});
